<template>
  <div id="video_container" class="fullwidth">
    <iframe id="video_iframe" style="width:100%;height:100%!important;min-height:100%;" :src="frame_src" allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true" scrolling="no"></iframe>
    <!--<div id="pano"></div>-->
  </div>
</template>



<script>
const SITE_URL = process.env.SITE_URL

export default {
  data: function() {
    return {
      fileName: "krpano.html",
      input: "",
      player: null
    };
  },
  computed: {
    assignment() {
      return this.$store.state.assignment
    },
    frame_src: function(){
      let scene = this.assignment.task.scene_number;
      console.log(this.$route.query.page)
      return SITE_URL + '/videos/krpano.html?xml=scenes/' + this.assignment.chapter.source_folder + '/scen_' + scene + '/scene.xml';
    }
  },
  methods: {
    get_krpano(){
      let iframe = document.getElementById("video_iframe");
      console.log(iframe)
      //let krpano = iframe.contentDocument.getElementById("krpanoSWFObject")
      //console.log(iframe.contentDocument);
    },
    player_ready(e){
      this.player = e.detail.player;
      console.log(this.player);
    },
    continue_after_video(){
      this.$router.push({path: `/assignment/${this.$store.state.assignment.slug}/introduction`})
    }
  },
  mounted: function() {
    window.document.addEventListener('player_ready', this.player_ready, false)
    window.document.addEventListener('continue_after_video', this.continue_after_video, false)
  }

}
</script>
